import { render, staticRenderFns } from "./InformacoesEsterilizacaoMaterialGenerico.vue?vue&type=template&id=76e74165&"
import script from "./InformacoesEsterilizacaoMaterialGenerico.vue?vue&type=script&lang=js&"
export * from "./InformacoesEsterilizacaoMaterialGenerico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../front-end/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports